import useTranslation from '../../hooks/useTranslation';
import { useSelector } from 'react-redux';
import timeFormAPI from '../../api/ui/timeFormAPI';
import { useEffect, useState } from 'react';
import { create } from './table-schema';
import logDataAPI from "../../constants/logDataAPI";
import changeNumApi from "../../api/ui/changeNumApi";

function useSchemaTransactionAttemptLog() {
  const { t } = useTranslation();
  const locale = useSelector((accountNo) => accountNo.language.locale);

  /**
   * 헤더에 표시할 항목의 개수
   */
  const size = 6;

  /**
   * 테이블 헤더에 표시할 항목 문자열 배열
   */
  const headerKeys = [
    "admin.log.user.transactionAttempt.table.head.key", // "거래 시도 ID",
    "admin.log.user.transactionAttempt.table.head.accountNo", // "유저 ID",
    "admin.log.user.transactionAttempt.table.head.walletAddress", // "시도 지갑 주소",
    "admin.log.user.transactionAttempt.table.head.tokenType", // "토큰 종류",
    "admin.log.user.transactionAttempt.table.head.value", // "토큰수량 혹은 NFT ID",
    "admin.log.user.transactionAttempt.table.head.transactionType", // "거래 종류",
    "admin.log.user.transactionAttempt.table.head.status", // "거래 상태",
    "admin.log.user.transactionAttempt.table.head.createdAt", // "시도 일시",
  ];

  /**
   * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
   *
   * 오브젝트 키는 param1, param10 등의 형식으로 param 다음에 숫자를 붙여서 사용한다.
   *
   * param1은 헤더의 첫번째 표시되는 항목이다.
   *
   * 헤더에는 표시되지 않지만 상세에 표시될 항목의 경우 headSize 이후의 숫자를 사용한다.
   *
   * key는 반드시 있어야 한다.
   * @param {object} row
   * @returns
   */
  const parse = (row) => {
    const index = row?.index;
    const key = row?.key;
    const tokenType = logDataAPI.TokenType(row?.tokenType);
    const accountNo = row?.accountNo;
    const value = tokenType === 'PERPLAY' ? row?.value : changeNumApi.div18(row?.value);
    const walletAddress = row?.walletAddress;
    const transactionType = logDataAPI.walletTransactionType(row?.transactionType);
    const createdAt = timeFormAPI.changeDataLog(row?.createdAt);
    const status = row?.status;

    return {
      key: index, // 키는 반드시 있어야 한다.
      param1: key,
      param2: accountNo,
      param3: walletAddress,
      param4: tokenType,
      param5: value,
      param6: transactionType,
      param7: status,
      param8: createdAt,
    };
  };

  /**
   * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
   *
   * 입력값인 row는 위의 parse에서 변환된 값이다.
   *
   * @param {object} row
   * @returns
   */
  const details = (row) => {
    const array = [];
    if (row) {
      //
    }
    return array;
  };

  const [schema, setSchema] = useState();

  useEffect(() => {
    const headers = headerKeys.map((key) => t(key));
    const schema = create({
      headSize: size,
      heads: headers,
      parseFunc: parse,
      detailFunc: details,
    });
    setSchema(schema);
  }, [locale]);

  return { schema: schema };
}

export default useSchemaTransactionAttemptLog;
